const handleClick = (e) => {
    const element = e.srcElement.parentElement;
    if(!element) return;

    element.classList.toggle("open");
}
const init = () => {
    const elements = document.querySelectorAll("aside.need-help header");
    if (elements) {
        [].forEach.call(elements, element => {
            element.addEventListener("click", handleClick);
        })        
    }
}

document.addEventListener("DOMContentLoaded", init);